import { inject, Injectable } from '@angular/core';
import type { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string) {
        // "lang" is either "es" or a scoped "scopeName/es" — only the language code should be
        // lowercased; the scope segment must keep its exact casing to match its folder on disk.
        const slashIndex = lang.lastIndexOf('/');
        const path =
            slashIndex === -1
                ? lang.toLowerCase()
                : `${lang.slice(0, slashIndex)}/${lang.slice(slashIndex + 1).toLowerCase()}`;
        return this.http.get<Translation>(`${environment.baseUrl}/i18n/${path}.json?v=${environment.i18nVersion}`);
    }
}
